<script lang="ts">
  export let images: string[] = [];
  export let showThumbnails: boolean = true;
  export let imageHeight: string = "400px";
  export let showStoreName: boolean = true;
  export let storeName: string = "";
  export let storeNameTextColor: string = "#ffffff";
  export let storeNameTextShadow: string = "1px 1px 3px rgba(0,0,0,0.7)";
  export let storeNameBackgroundColor: string = "rgba(0, 0, 0, 0.5)";
  export let storeNamePadding: string = "5px 10px";
  export let storeNameBottomOffset: string = "10px";
  export let storeNameLeftOffset: string = "10px";
  export let storeNameFontSize: string = "1.5rem";
  export let storeNameFontWeight: string = "bold";
  export let storeNameLetterSpacing: string = "normal";
  let activeIndex = 0;

  $: noImages = !images || images.length === 0;

  function setActive(index: number) {
    activeIndex = index;
  }

  function next() {
    activeIndex = (activeIndex + 1) % images.length;
  }

  function prev() {
    activeIndex = (activeIndex - 1 + images.length) % images.length;
  }
</script>

<div class="banner-container">
  {#if noImages}
    <div class="fallback-banner" style:height={imageHeight}>
      <div class="store-name-fallback">{storeName}</div>
    </div>
  {:else}
    <div class="main-image">
      {#if images.length > 0}
        <img src={images[activeIndex]} alt="" style="height: {imageHeight};" />
        {#if showStoreName && storeName}
          <div
            class="store-name"
            style:color={storeNameTextColor}
            style:text-shadow={storeNameTextShadow}
            style:background={storeNameBackgroundColor}
            style:padding={storeNamePadding}
            style:bottom={storeNameBottomOffset}
            style:left={storeNameLeftOffset}
            style:font-size={storeNameFontSize}
            style:font-weight={storeNameFontWeight}
            style:letter-spacing={storeNameLetterSpacing}
          >
            {storeName}
          </div>
        {/if}
        {#if images.length > 1}
          <button class="nav-button prev" on:click={prev} aria-label="Previous">
            <span class="arrow" />
          </button>
          <button class="nav-button next" on:click={next} aria-label="Next">
            <span class="arrow" />
          </button>
        {/if}
      {/if}
    </div>
  {/if}

  {#if !noImages && showThumbnails && images.length > 1}
    <div class="thumbnails">
      {#each images as image, i}
        <button
          class="thumb"
          class:active={i === activeIndex}
          on:click={() => setActive(i)}
        >
          <img src={image} alt="" />
        </button>
      {/each}
    </div>
  {/if}
</div>

<style lang="scss">
  .banner-container {
    width: 100%;
  }

  .main-image {
    position: relative;

    img {
      width: 100%;
      object-fit: cover;
      display: block;
    }
  }

  .store-name {
    position: absolute;
    border-radius: 4px;
    line-height: 1.2;
  }

  .nav-button {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 30px;
    height: 30px;
    background: rgba(0, 0, 0, 0.5);
    border: none;
    border-radius: 50%;
    cursor: pointer;
    padding: 0;
    transition: background-color 0.2s;

    &:hover {
      background: rgba(0, 0, 0, 0.7);
    }

    .arrow {
      display: block;
      width: 8px;
      height: 8px;
      border: solid white;
      border-width: 0 2px 2px 0;
      margin: auto;
    }

    &.prev {
      left: 10px;
      .arrow {
        transform: rotate(135deg);
        margin-left: 12px;
      }
    }

    &.next {
      right: 10px;
      .arrow {
        transform: rotate(-45deg);
        margin-left: 8px;
      }
    }
  }

  .thumbnails {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 10px;
  }

  .thumb {
    padding: 0;
    border: none;
    background: none;
    cursor: pointer;
    opacity: 0.6;
    transition: opacity 0.3s;

    &:hover {
      opacity: 0.8;
    }

    &.active {
      opacity: 1;
    }

    img {
      width: 100%;
      height: 80px;
      object-fit: cover;
    }
  }

  .fallback-banner {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    background-color: var(--brand-color-2);
  }

  .store-name-fallback {
    color: var(--brand-color-1);
    font-size: 2.5rem;
    font-weight: bold;
    text-align: center;
    padding: 20px;
  }
</style> 